import { createZustandShallowStore } from '@/lib/zustand';
import { SetStoreState } from '@/types/use';
import { GridApi } from 'ag-grid-community';
import { useCallback } from 'react';

type TableAGStoreProps = {
    /**
     * Lưu lại tất cả ref của table-ag dạng Record<string, GridAPI> đang hiện thị trên UI
     * */
    tableAGRefs: Record<string, GridApi<any> | undefined>;

    /**Hàm set các state trong store này
     * @description VUI LÒNG SÀI CẨN THẬN. COI CHỪNG BỊ GHI ĐÈ LÊN STATE CŨ
     */
    setTableAGState: SetStoreState<Partial<TableAGStoreProps> | undefined>;
};

export const useTableAGStore = createZustandShallowStore<TableAGStoreProps>(
    (set, get) => {
        return {
            tableAGRefs: {},

            setTableAGState(fn) {
                set((st) => {
                    const _obj = typeof fn === 'function' ? fn(st) : fn;

                    return {
                        ..._obj,
                    };
                });
            },
        };
    }
);

/**hook của table ag */
export const useTableAG = () => {
    const { tableAGRefs } = useTableAGStore((x) => x);

    /**Thực hiện resize toàn bộ các table-ag đang hợp lệ trên UI */
    const triggerSizeColumnToFit = useCallback(() => {
        const tableKeys = Object.keys(tableAGRefs);

        if (tableKeys.length) {
            tableKeys.forEach((key) => {
                const gridApi = tableAGRefs[key];
                if (gridApi) {
                    gridApi.sizeColumnsToFit();
                }
            });
        }
    }, [tableAGRefs]);

    return {
        /**Set table size fit screen */
        triggerSizeColumnToFit,
    };
};
